import * as Constants from './constants'

export const nhomKhachHangListRequest = (formData, callback) => {
  return {
    type: Constants.NHOM_KHACHHANG_LIST_REQUESTING,
    payload: formData,
    callback
  }
}

export const nhomKhachHangListSuccess = (data) => {
  return {
    type: Constants.NHOM_KHACHHANG_LIST_SUCCESS,
    data
  }
}

export const nhomKhachHangListError = (error) => {
  return {
    type: Constants.NHOM_KHACHHANG_LIST_ERROR,
    error
  }
}

export const nhomKhachHangDetailRequest = (formData, callback) => {
  return {
    type: Constants.NHOM_KHACHHANG_DETAIL_REQUESTING,
    payload: formData,
    callback
  }
}

export const nhomKhachHangDetailSuccess = (data) => {
  return {
    type: Constants.NHOM_KHACHHANG_DETAIL_SUCCESS,
    data
  }
}

export const nhomKhachHangDetailError = (error) => {
  return {
    type: Constants.NHOM_KHACHHANG_DETAIL_ERROR,
    error
  }
}

export const nhomKhachHangUpdateRequest = (formData, callback) => {
  return {
    type: Constants.NHOM_KHACHHANG_UPDATE_REQUESTING,
    payload: formData,
    callback
  }
}

export const nhomKhachHangUpdateSuccess = (response) => {
  return {
    type: Constants.NHOM_KHACHHANG_UPDATE_SUCCESS,
    payload: response
  }
}

export const nhomKhachHangUpdateError = (error) => {
  return {
    type: Constants.NHOM_KHACHHANG_UPDATE_ERROR,
    error
  }
}

export const nhomKhachHangRemoveRequest = (formData, callback) => {
  return {
    type: Constants.NHOM_KHACHHANG_REMOVE_REQUESTING,
    payload: formData,
    callback
  }
}

export const nhomKhachHangRemoveSuccess = (response) =>{
  return {
    type: Constants.NHOM_KHACHHANG_REMOVE_SUCCESS,
    payload: response
  }
}

export const nhomKhachHangRemoveError = (error) => {
  return {
    type: Constants.NHOM_KHACHHANG_REMOVE_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/NhomKhachHang/actions.js